<template>
  <section class="d-flex flex-column h-full">
    <div class="fixed-header w-full">
    <TopAppBar
      :leftBtnMode="leftBtnMode"
      :rightBtnMode="rightBtnMode"
      :title="title"
      :leftBtnMethod="leftBtnMethod"
      :rightBtnMethod="rightBtnMethod"
      staticMode="true"
    ></TopAppBar>
    <div class="tab_bar w-full">
      <div class="nav-content teal lighten-2 mdc-tab-bar top-tab-bar" role="tablist">
        <div class="mdc-tab-scroller">
          <div class="mdc-tab-scroller__scroll-area mdc-tab-scroller__scroll-area--scroll mgb-000">
            <ul class="tabs w-full mdc-tab-scroller__scroll-content">
              <li class="tab">
                <a
                  href="#tab1"
                  class="w-full d-block t-color-title tab mdc-tab mdc-tab--active"
                  role="tab"
                  tabindex="0"
                >
                  <span class="mdc-tab__content">
                    <span class="mdc-tab__text-label">{{$t('1497')}}</span>
                  </span>
                  <span class="mdc-tab-indicator mdc-tab-indicator--active">
                    <span class="mdc-tab-indicator__content mdc-tab-indicator__content--underline"></span>
                  </span>
                  <span class="mdc-tab__ripple mdc-ripple-upgraded"></span>
                </a>
              </li>
              <li class="tab">
                <a
                  href="#tab2"
                  class="w-full d-block t-color-title tab mdc-tab"
                  role="tab"
                  tabindex="1"
                >
                  <span class="mdc-tab__content">
                    <span class="mdc-tab__text-label">{{$t('1498')}}</span>
                  </span>
                  <span class="mdc-tab-indicator">
                    <span class="mdc-tab-indicator__content mdc-tab-indicator__content--underline"></span>
                  </span>
                  <span class="mdc-tab__ripple mdc-ripple-upgraded"></span>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    </div>
    <!-- <div class="flex-grow-1 scroll-y"> -->
    <!-- <HelpDeskList></HelpDeskList> -->
    <!-- <transition name="fade" mode="out-in">
                <router-view></router-view>
            </transition>    
    </div>-->
    <div id="tab1" class="t-color-gray2 ripple-item pdl-16 pdr-16 pdt-16 pdb-34">
        <div class="h-50"></div>
        <div class="h-32"></div>
        <img src="images/helpdesk/notice_nodata.svg" alt="" class="mgx-auto no-data-image">
        <div class="pdt-24 pdl-16 pdr-16 pdb-4 t-subtitle3 t-color-title t-center font-m l-spacing48">내용을 준비 중입니다
        </div>
        <div class="pdt-4 pdl-16 pdr-16 pdb-4 t-body3 t-color-content1 t-center l-spacing42">FAQ 내용을 준비하고 있습니다.<br>
            양해 부탁드립니다!</div>

    </div>

    <div id="tab2"  class="t-color-gray2 ripple-item  pdt-16 pdb-34">
        <div class="pdl-16 pdr-16 pdb-16 mgb-16 listItems d-flex justify-content-between">
            <div class="t-body2 t-color-content1  font-m d-flex align-items-center">나의 문의 <span
                    class="queryCount bg-dark t-color-white t-caption t-center w-18 h-16 d-inline-block mgl-4">22</span></div>
            <div class="t-body2 t-color-warning  font-m">1:1 문의하기</div>
        </div>
        <div class="h-50"></div>
        <div class="h-32"></div>
        <img src="images/helpdesk/notice_nodata.svg" alt="" class="mgx-auto no-data-image">
        <div class="pdt-24 pdl-16 pdr-16 pdb-4 t-subtitle3 t-color-title t-center font-m l-spacing48">내용을 준비 중입니다
        </div>
        <div class="pdt-4 pdl-16 pdr-16 pdb-4 t-body3 t-color-content1 t-center l-spacing42">FAQ 내용을 준비하고 있습니다.<br>
            양해 부탁드립니다!</div>

    </div>
  </section>
</template>

<script>
/**
 * 나의 학습 메인 컴포넌트(my learn main component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import TopAppBar from "@/components/TopAppBar.vue";
import { topAppBarMixin } from "@/mixins/topAppBar.js";
//import HelpDeskList from '@/components/helpDesk/List'
import { MDCTabBar, MDCTabBarFoundation } from "@material/tab-bar";

export default {
  name: "learn",

  data() {
    return {
      // title
      leftBtnMethod: () => {
        this.$router.go(-1);
      },
      tabBar: null,
    };
  },
  components: {
    TopAppBar,
    //HelpDeskList,
    // Faq: () => import("@/components/helpDesk/Faq.vue"),
    // Inqueriy: () => import("@/components/helpDesk/Inqueriy.vue"),
  },

  mixins: [topAppBarMixin],

  watch: {
    $route(to, from) {},
  },

  mounted() {
    //this.setTopAppBarHomeBlank(this.$t('66'))
    $(document).ready(function () {
      $(".tabs").tabs();
    });
    this.tabBar = new MDCTabBar(document.querySelector(".mdc-tab-bar"));
    this.setTabActive();
    this.setTopAppBarBackSearch(this.$t("1496"));
  },

  methods: {
    setTabActive() {
      let status = this.$route.query.status;
      if (status === "FAQ") {
        this.tabBar.activateTab(0);
      } else if (status == "INQUERY") {
        this.tabBar.activateTab(1);
      } else {
        this.tabBar.activateTab(0);
      }
    },
  },
};
</script>

<style scoped>
.fixed-header {
  position: fixed;
  top: 0;
}
.nav-extended .brand-logo,
.nav-content * {
  font-family: noto-regular;
}

.nav-extended .brand-logo {
  font-size: 20px;
  letter-spacing: -0.6;
}

.tabs .tab a:focus,
.tabs .tab a:focus.active {
  background-color: #f5f5f5;
  outline: none;
}

.tabs .indicator {
  background: #2d6dcc;
}

.mdc-elevation--z3 {
  border-radius: 4px;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.26);
  background-color: #ffffff;
}

.tabs .tab {
  width: 50%;
}
.listItems {
  border-bottom: 1px solid #e6eced;
}
.no-data-image {
            width: 123px;
            height: 143px;
        }
.queryCount {
  border-radius: 50%;
  line-height: 1.7;
}
#tab1, #tab2{
    margin-top: 112px;
}
</style>